/* eslint-disable jsx-a11y/label-has-associated-control */
import { useEnhancedTranslation } from '@app/hooks';
import { Field, FieldProps } from 'formik';
import { FC } from 'react';
import { Trans } from 'react-i18next';
import cx from 'classnames';

export type AgreementType = 'email' | 'sms';

type AgreementProps = {
  className?: string;
  textKey?: string;
  agreementType: AgreementType;
  name: string;
};

export const Agreement: FC<AgreementProps> = ({
  className,
  textKey = 'common.form.agreement',
  agreementType,
  name,
}) => {
  const { t } = useEnhancedTranslation({});
  const fieldName = `${name}.${agreementType}`;

  return (
    <Field name={fieldName}>
      {({ field, form }: FieldProps) => (
        <label className={cx(className, 'checkbox-input-label')}>
          <input
            {...field}
            id={fieldName}
            checked={field.value}
            onChange={() => form.setFieldValue(fieldName, !field.value)}
            className={cx('checkbox-input')}
            type="checkbox"
          />
          <p className="checkbox-input-text">
            <Trans t={t} i18nKey={textKey} />
          </p>
        </label>
      )}
    </Field>
  );
};
